import PropTypes from 'prop-types';

export const SPIN_CAR_VIEWER_CREATIVE_ID = 'edm-entry-spincar-360';
export const APPEND_ARGUMENTS = [
  'disableautospin',
  'disabledrawer',
  'hideprotection',
  'hidevehiclehits',
  'hidefeaturetour',
  'hidelivevideo',
  'hidecarousel',
  'hidecarfax',
  'lang=en-us',
  'stscolor=008CFF',
];
export const SpinCarPhotoInfo = PropTypes.shape({
  extIntUrl: PropTypes.string,
});
